import { IUser } from 'data/entities/credentials.entity';
import { IUserProfile } from 'data/entities/userprofile.entity';
import { getUser } from 'data/usecases/getUser';
import { getUserProfile } from 'data/usecases/userprofile';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getSubscriptions } from 'data/usecases/subscriptions';
import { SubscriptionsResponseModel } from 'data/entities/subscriptions.entity';

interface IUserContext {
    isRegistered: boolean;
    user: IUser | null;
    userInfo: IUserProfile | null;
    isLoading: boolean;
    subscriptions: SubscriptionsResponseModel | null;
}

interface IProps {
    children: React.ReactNode;
}

const UserContext = createContext<IUserContext | null>(null);

export const UserProvider = ({ children }: IProps): JSX.Element => {
    const [userInfo, setUserInfo] = useState<IUserProfile | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [subscriptions, setSubscriptions] = useState<SubscriptionsResponseModel | null>(null);
    useEffect(() => {
        (async () => {
            if (!userInfo) {
                const getInfo = await getUserProfile();
                const getSubscription = await getSubscriptions();
                setUserInfo(getInfo);
                setSubscriptions(getSubscription);
                setIsLoading(false);
            }
        })();
    }, [userInfo]);
    const user = getUser();

    const isRegistered: boolean = (user?.role && user.role === 'Registered') || false;
    return (
        <UserContext.Provider value={{ isRegistered, user, userInfo, isLoading, subscriptions }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) throw new Error('useUser must be used within an UserProvider');
    return context;
};
